<template>
  <div class="export">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem>实名验证</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">实名验证</div> 
      </div>
    </div>
    
    <div class="export-content">
      <div class="content">
        <p class="title">实名制验证记录</p>
        <div class="btn">
          <Button :loading="loading" icon="ios-sync" @click="loading=true;init();">刷新</Button>
        </div>
        <Table
          :border="false"
          row-key="id"
          :columns="columns"
          :data="list"
        >
          <template slot-scope="{ row, index }" slot="name">实名制验证记录</template>
          <template slot-scope="{ row, index }" slot="timesCount">{{row.timesCount}}</template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "host-product",
  data() {
    return {
      columns: [
        {
          title: "名称",
          slot: "name",
          key: "name",
          align: "center"
        },
        {
          title: "验证次数",
          key: "timesCount",
          slot: "timesCount",
          align: "center"
        },
      ],
      list: [],
      loading: false,
    };
  },
  async created() {
    this.init();
  },
  computed: {
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
      getIDcheck: "hostCommonModule/getIDcheck"
    }),
    async init() {
      this.list = [];
      let info = await this.getIDcheck();
      this.list.push(info);
      this.loading = false;
    },
  }
};
</script>

<style scoped lang="scss">
.export {
  &-content {
    min-width: 600px;
    padding: 30px 30px 50px 30px;
    .content {
      background-color: #fff;
      padding: 0 30px 30px;
      .title {
        line-height: 50px;
        font-size: 16px;
        border-bottom: 1px solid #e8e8e8;
      }
      .btn {
        margin: 20px 0;
      }
    }
  }
}
.export-content {
  /deep/ .ivu-select-dropdown {
    width: 200px;
  }
}
</style>
